module.exports = __webpack_public_path__ + "media/holler.5a96afce.webm";